import { useState } from "react";

export function useDialogs(initialStates, closeCallback) {
  const [dialogs, setDialogs] = useState(initialStates);

  const handleOpenDialog = (dialogName) => {
    setDialogs((prevState) => ({
      ...prevState,
      [dialogName]: true,
    }));
  };

  const handleCloseDialog = (dialogName, callback) => {
    if (callback) callback();
    if (closeCallback) closeCallback();

    setDialogs((prevState) => ({
      ...prevState,
      [dialogName]: false,
    }));
  };

  return { dialogs, handleOpenDialog, handleCloseDialog };
}
